import { defineMessages } from 'react-intl'

export default defineMessages({
  download: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.download',
    defaultMessage: 'Download',
  },
  downloadAll: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.downloadAll',
    defaultMessage: 'Download ZIP'
  },
  revised: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.revised',
    defaultMessage: 'Revised'
  },
  accept: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.accept',
    defaultMessage: 'Approve recordings'
  },
  decline: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.decline',
    defaultMessage: 'Reject'
  },
  feedbackMessage: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.feedbackMessage',
    defaultMessage: 'Enter feedback (required on rejection)',
  },
  loading: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.feedback.loading',
    defaultMessage: 'Loading',
  },
  submit: {
    id: 'containers.CustomerOrdersPage.components.OrderDetailsPane.components.OrderDeliveries.components.Delivery.feedback.submit',
    defaultMessage: 'Submit',
  }
})
